import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconDateSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path d="M6 8.66665V7.33331H4.66667V8.66665H6Z" fill="currentColor" />
      <path d="M7.33333 7.33331H8.66667V8.66665H7.33333V7.33331Z" fill="currentColor" />
      <path d="M11.3333 8.66665V7.33331H10V8.66665H11.3333Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.66665H12.6667C13.4 2.66665 14 3.26665 14 3.99998V13.3333C14 14.0666 13.4 14.6666 12.6667 14.6666H3.33333C2.59333 14.6666 2 14.0666 2 13.3333L2.00667 3.99998C2.00667 3.26665 2.59333 2.66665 3.33333 2.66665H4V1.99998C4 1.63331 4.3 1.33331 4.66667 1.33331C5.03333 1.33331 5.33333 1.63331 5.33333 1.99998V2.66665H10.6667V1.99998C10.6667 1.63331 10.9667 1.33331 11.3333 1.33331C11.7 1.33331 12 1.63331 12 1.99998V2.66665ZM12 13.3333C12.3667 13.3333 12.6667 13.0333 12.6667 12.6666V5.99998H3.33333V12.6666C3.33333 13.0333 3.63333 13.3333 4 13.3333H12Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
